<div class="container">
  <ng-container *ngIf="!markDownDocument; then lastCallSection; else markDownDocumentSection" />

  <ng-template #lastCallSection>
    <mat-card>
      <mat-card-header>
        <div class="page-title">Smart Summary</div>
      </mat-card-header>
      <mat-card-content class="pt-16">
        <form (ngSubmit)="getSmartSummary()" #smartSummaryForm="ngForm">
          <grid-input [placeholder]="'Numero Sinistro'" [(ngModel)]="smartSummaryFormModel.numSinistro"
                      name="numSinistro" grid-tab-index="0" showClear="false" required>
            <span slot="description">Numero Sinistro</span>
          </grid-input>

          <mat-card-actions>
            <grid-button [gridDisabled]="!smartSummaryForm.form.valid" (click)="resetForm()" class="ml-auto" variant="secondary-ghost">Reset</grid-button>
            <grid-button [gridDisabled]="!smartSummaryForm.form.valid" type="submit" class="ml-1.5" variant="secondary">Ricerca</grid-button>
          </mat-card-actions>
        </form>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <div class="page-sub-title">Ultime interrogazioni</div>
      </mat-card-header>
      <mat-card-content class="pt-16">
        <table mat-table [dataSource]="lastCallsRows" class="mat-elevation-z8">
          <ng-container matColumnDef="numSinistro">
            <th mat-header-cell *matHeaderCellDef>Numero Sinistro</th>
            <td mat-cell *matCellDef="let element"> {{ element.numSinistro }}</td>
          </ng-container>
          <ng-container matColumnDef="dataRichiesta">
            <th mat-header-cell *matHeaderCellDef>Data Richiesta</th>
            <td mat-cell *matCellDef="let element"> {{ formatDate(element.dataRichiesta) }}</td>
          </ng-container>
          <ng-container matColumnDef="stato">
            <th mat-header-cell *matHeaderCellDef>Stato</th>
            <td mat-cell *matCellDef="let element">
              <grid-icon *ngIf="element.stato === SMART_SUMMARY_STATES.INAVLID" slot="icon" name="alert-circle-outline" color="grid-action-primary" size="m" />
              <grid-icon *ngIf="element.stato === SMART_SUMMARY_STATES.PENDING" slot="icon" name="hourglass-outline" color="grid-action-primary" size="m" />
              <grid-icon *ngIf="element.stato === SMART_SUMMARY_STATES.COMPLETED" slot="icon" name="checkmark-circle-outline" color="grid-action-primary" size="m" />
            </td>

          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="action-cell">
              <grid-button [gridDisabled]="element.stato !== SMART_SUMMARY_STATES.COMPLETED" (click)="consulta(element.numSinistro,element.smartSummaryId)" variant="secondary" size="extra-small">
                CONSULTA
              </grid-button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="lastCallsColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: lastCallsColumns;"></tr>
        </table>

      </mat-card-content>
    </mat-card>
  </ng-template>

  <ng-template #markDownDocumentSection>
    <grid-toast [iconName]="'warning'" class="disclaimer-toast"
                [type]="'warning'" [dismissable]="true" [timeout]="0">
      <span slot="name"><b>Disclaimer</b></span>
      <div slot="text">
        Questo Smart Summary &egrave; stato generato tramite intelligenza artificiale.
        <br>Le informazioni riportate potrebbero essere inesatte.
        <br>Prima dell’utilizzo &egrave; necessario verificare il rilascio di adeguata informativa privacy e l’acquisizione degli atti di consenso
        esplicito dell’interessato per l’utilizzo dei dati.
      </div>
    </grid-toast>
    <mat-card class="markdown-card">
      <div class="markdown-header">
        <div class="page-sub-title">{{ markDownDocument?.documentTitle }}</div>
        <grid-icon-button iconName="close" variant="primary-ghost" (click)="closeDetailSection()" />
      </div>
      <div class="markdown-container">
        <div *ngFor="let section of markDownDocument?.documentSections">
          <markdown [data]="section.text" />
          <div class="links-section">
            <grid-button *ngFor="let link of section.links" (click)="goToLink(link.ged)" variant="secondary-ghost" size="extra-small">{{ link.text }}</grid-button>
          </div>
        </div>
      </div>

      <div class="markdown-footer" *ngIf="!markDownDocument?.isFeedbackPresent">
        <grid-icon-button iconName="happy-outline" variant="primary-ghost" (click)="openFeedbackModal(1)" />
        <grid-icon-button iconName="sad-outline" variant="primary-ghost" (click)="openFeedbackModal(0)" />
      </div>
    </mat-card>
  </ng-template>
</div>

<app-feedback-modal [idSinistro]="idSinistro" [smartSummaryId]="smartSummaryId" [isOpen]="isFeedbackModalOpen" [feedbackType]="feedbackType" (closeModal)="setFeedbackModalOpen($event)" />
